import { useEffect, useState } from "react";

interface MobileState {
    isTab: boolean | null;
    isMobile: boolean | null;
}

const useMobileDetect = (): MobileState => {
    const [isTab, setTab] = useState<boolean | null>(null);
    const [isMobile, setIsMobile] = useState<boolean | null>(null);

    useEffect(() => {
        if (typeof window !== undefined) {
            const handleResize = () => {
                const tab = window.innerWidth < 1024; // Example threshold for tab devices
                setTab(tab);

                const mobile = window.innerWidth < 767; // Example threshold for mobile devices
                setIsMobile(mobile);
            };

            // Set initial state on component mount
            handleResize();

            // Add event listener for window resize
            window.addEventListener("resize", handleResize);

            // Remove event listener on component unmount
            return () => window.removeEventListener("resize", handleResize);
        }
    }, []); // Empty dependency array to run only on mount and unmount

    return { isTab, isMobile };
};

export default useMobileDetect;
